import { useAuthStore } from '../index';
import { useThemeStore } from '../index';
import { toast } from '../index';
import { Icon } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';
import { authEndpoints } from '../api/auth-endpoints';

/** Cycles auto → dark → light without reloading; the choice is saved in the profile. */
export function ThemeToggle() {
  const { t } = useTranslation();
  const mode = useThemeStore((s) => s.mode);
  const cycle = useThemeStore((s) => s.cycle);
  const status = useAuthStore((s) => s.status);
  const setMe = useAuthStore((s) => s.setMe);

  const onClick = async () => {
    cycle();
    const next = useThemeStore.getState().mode;
    toast('info', t(`core.theme.${next}`), t(`core.theme.${next}Detail`));
    if (status === 'authenticated') {
      try {
        setMe(await authEndpoints.preferences({ theme: next }));
      } catch {
        /* kept locally */
      }
    }
  };

  return (
    <button
      type="button"
      className="btn ico ghost"
      onClick={() => void onClick()}
      aria-label={t('core.theme.toggle')}
      title={t(`core.theme.${mode}`)}
    >
      <Icon name={mode === 'dark' ? 'moon' : 'sun'} size={17} />
    </button>
  );
}
